import { NETWORKS, RPC_URL } from "../constants/blockchain";

export const getMainnetURI = () => RPC_URL[NETWORKS.AURORA];
